/**
 * Consistente datum/tijd-formattering in Nederlandse stijl (nl-NL).
 * Server stuurt datums vaak als UTC zonder 'Z'; die worden correct als UTC geïnterpreteerd.
 */

const NL = 'nl-NL';

/** Server-datums (bijv. "2024-01-15 14:30:00" zonder Z) als UTC parsen. */
export function parseServerDate(dateStr) {
  if (!dateStr) return null;
  const s = String(dateStr).trim();
  if (!s) return null;
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  const iso = s.replace(' ', 'T') + 'Z';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

/** Formatteer als datum (bijv. 15-1-2024). */
export function formatDateNL(value) {
  const d = value instanceof Date ? value : parseServerDate(value);
  if (!d || isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(NL);
}

/** Formatteer als datum + tijd (bijv. 15-1-2024 14:30:00). */
export function formatDateTimeNL(value, options = {}) {
  const d = value instanceof Date ? value : parseServerDate(value);
  if (!d || isNaN(d.getTime())) return '—';
  return d.toLocaleString(NL, { dateStyle: 'short', timeStyle: 'short', ...options });
}

/** Formatteer als tijd (bijv. 14:30:00). */
export function formatTimeNL(value) {
  const d = value instanceof Date ? value : parseServerDate(value);
  if (!d || isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString(NL, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
